import classNames from "classnames";

import { useCheckboxesSchema } from "./useCheckboxesSchema";
import { BUDGET_CHAPTER } from "../SchemaTypes";
import Field from "../Field";
import { useParsedFieldProps } from "./useParsedFieldProps";
import BudgetChapterInput from "../../Input/BudgetChapterInput";
import Collapse from "../../Utils/Collapse";
import CollapseSwitch from "../../Utils/CollapseSwitch";
import CollapseContent from "../../Utils/CollapseContent";
import { useFormField } from "../withFormStore";
import BudgetAmount from "./Budget/BudgetAmount";

const BudgetChapterField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { fieldName, label } = fieldProps;
  const { parent, defaultValues, unit, defaultExpanded } = props;

  // Use checboxes schema for budget chapters as they are a set of options and associated
  // validations from this hook work perfectly with this field.
  const schema = useCheckboxesSchema({
    type: BUDGET_CHAPTER,
    required: false,
    parent
  });

  const { total: chapterTotal = 0 } = useFormField(fieldName);

  const switchClassName = classNames(
    "btn",
    "btn-unstyled",
    "btn-block",
    "padding-sm",
    "form-label",
    "border-bottom",
    "margin-bottom-none"
  );

  return (
    <Field {...fieldProps} schema={schema} label={false}>
      <Collapse expanded={defaultExpanded}>
        <div className="border rounded margin-bottom-sm">
          <CollapseSwitch
            className={switchClassName}
            labelClassName="d-flex justify-content-between align-items-center"
            headingLevel={3}
          >
            <span>{label}</span>

            <BudgetAmount amount={chapterTotal} unit={unit} className="margin-x-sm" />
          </CollapseSwitch>

          <CollapseContent>
            <BudgetChapterInput
              {...inputProps}
              defaultValues={defaultValues}
              unit={unit}
              className="padding-sm"
            />
          </CollapseContent>
        </div>
      </Collapse>
    </Field>
  );
};

export default BudgetChapterField;
